module.exports = __webpack_public_path__ + "static/media/2-N-okas-mobile.f1d7416e.webp";